module.exports = __webpack_public_path__ + "static/media/conveniosempresariales.95a3d858.svg";